function trimInput(e) {
    "use strict";
    var key;
    if (window.event) {
        key = window.event.keyCode; // IE
    } else {
        key = e.which;
    }
    if ("v" == String.fromCharCode(key).toLowerCase()) {
        e.target.value = $.trim(e.target.value);
        return false;
    }
    return true;
}
function preventDef(event) {
    "use strict";
    // Firefox prevent default action can be used with onContextMenu for instance
    event.preventDefault();
    event.stopPropagation();
    return false;
}
function setNoContext() {
    "use strict";
    // Used in ie to disable context menu
    document.oncontextmenu = new Function("return false");
}
function removeNoContext() {
    "use strict";
    // Used in ie to reenable the context menu
    document.oncontextmenu = null;
}
;
define("legacy/formutil", function(){});

